import {
  ADD_IMAGE,
  ADD_IMAGE_SUCCESS,
  ADD_IMAGE_CLEAN,
  ADD_IMAGE_ERROR,
} from "./actionTypes"

export const addImage = form => ({
  type: ADD_IMAGE,
  payload: { form },
})

export const addImageSuccess = image => {
  return {
    type: ADD_IMAGE_SUCCESS,
    payload: { image },
  }
}

export const addImageClean = () => {
  return {
    type: ADD_IMAGE_CLEAN,
    payload: {},
  }
}

export const apiError = error => {
  return {
    type: ADD_IMAGE_ERROR,
    payload: error,
  }
}
